module.exports = __webpack_public_path__ + "90cb9bbb.svg";